import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    IBlenderAgent,
    IOperatorIdResponse,
    IUserDirectory,
} from '@dxp/core/models';
import { RbacApiService, AgentApiService } from '@dxp/core/api';

@Injectable({
    providedIn: 'root',
})
export class AgentDirectoryService {
    readonly #rbacApiService = inject(RbacApiService);
    readonly #agentApiService = inject(AgentApiService);

    fetchAgentDirectory(
        top: number,
        skip: number,
        searchQuery: string | undefined,
        requiresName: boolean,
        requiresEmail: boolean,
        requiresPhone: boolean,
        agentId?: string,
    ): Observable<IUserDirectory> {
        return this.#rbacApiService.getAgents(
            {
                limit: top,
                skip: skip,
                filterExpression: searchQuery ?? '',
            },
            [{ column: 'Name', descending: false }],
            undefined,
            {
                requiresName: requiresName,
                requiresEmail: requiresEmail,
                requiresPhone: requiresPhone,
            },
            agentId,
        );
    }

    fetchActiveAgents(
        searchQuery: string | undefined,
        businessUnitId: string | null | undefined,
        requiresName: boolean,
        requiresEmail: boolean,
        requiresPhone: boolean,
    ): Observable<IBlenderAgent[]> {
        return this.#agentApiService.getActiveAgents(
            'name asc',
            {
                requiresName: requiresName,
                requiresEmail: requiresEmail,
                requiresPhone: requiresPhone,
            },
            searchQuery,
            businessUnitId,
        );
    }

    fetchAgentOperatorId(
        agentId: string,
    ): Observable<IOperatorIdResponse | null> {
        return this.#agentApiService.getOperatorId(agentId);
    }
}
